import axios from "axios";
import GlobalURL from "./global";

const tokenData = JSON.parse(localStorage.getItem("token") || "null");

const httpclient = axios.create({
  baseURL: GlobalURL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": "true",
    "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
    "Access-Control-Allow-Headers": "Origin, Content-Type",
    "Content-Type": "application/json",
    Authorization: tokenData ? `Bearer ${tokenData}` : "",
  },
});

export default httpclient;
